/* Whitmore native swatches (replaces Swatch King): scroll arrows + colour photo swap on product cards. */
(function () {
  'use strict';

  // Show the arrow only while the row still has hidden tiles to the right.
  function bindArrow(row, arrow) {
    if (!row || !arrow || arrow.dataset.wmBound) return;
    arrow.dataset.wmBound = '1';
    var update = function () {
      arrow.hidden = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    };
    arrow.addEventListener('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      row.scrollBy({ left: row.clientWidth * 0.7, behavior: 'smooth' });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);
  }

  function initArrows(root) {
    root.querySelectorAll('.wm-sw').forEach(function (w) {
      bindArrow(w.querySelector('.variant-input-wrap'), w.querySelector('.wm-sw-arrow'));
    });
    root.querySelectorAll('[data-wm-gsw]').forEach(function (w) {
      bindArrow(w.querySelector('.wm-gsw__track'), w.querySelector('.wm-gsw__arrow'));
    });
  }

  // Product cards: hovering (or a first tap on touch) shows that colour's photo.
  var touch = window.matchMedia('(hover: none)').matches;

  function show(item) {
    var card = item.closest('.grid-product');
    if (!card || !item.dataset.src) return false;
    var img = card.querySelector('.grid-product__image-mask image-element img, .grid-product__image-mask img');
    if (!img) return false;
    if (!img.dataset.wmOrigSrc) {
      img.dataset.wmOrigSrc = img.getAttribute('src') || '';
      img.dataset.wmOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', item.dataset.srcset);
    img.setAttribute('src', item.dataset.src);
    card.classList.add('wm-gsw-on');
    card.querySelectorAll('.wm-gsw__item.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    item.classList.add('is-active');
    var link = card.querySelector('.grid-product__link');
    if (link) link.setAttribute('href', item.getAttribute('href'));
    return true;
  }

  document.addEventListener('mouseover', function (evt) {
    if (touch) return;
    var item = evt.target.closest && evt.target.closest('.wm-gsw__item');
    if (item) show(item);
  });

  document.addEventListener('click', function (evt) {
    var item = evt.target.closest('.wm-gsw__item');
    if (!item || !touch) return;
    // First tap previews the colour, a second tap on the same tile opens it.
    if (!item.classList.contains('is-active')) {
      if (show(item)) evt.preventDefault();
    }
  });

  function init() { initArrows(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Cards that arrive later (recommendations, quick view, infinite scroll).
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; initArrows(document); }, 400);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
